module.exports = __webpack_public_path__ + "static/media/Source Info.3b975224.txt";